// Chakra imports
import { Flex } from '@chakra-ui/react';
import { useContext } from 'react';
import { AuthContext } from '../../../contexts/auth-context';
import { observer } from 'mobx-react';
import { useAssetStore } from '../../../contexts/RootStoreProvider';
import AssetsList from './components/AssetsList';

const Assets = () => {
  const { currentUser, currentOrgs, currentOrgRoles } = useContext(AuthContext);
  const assetStore = useAssetStore();

  return (
    <Flex pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <Flex direction="column" width="stretch">
        <AssetsList currentUser={currentUser} currentOrgs={currentOrgs} currentUserRoles={currentOrgRoles} assetStore={assetStore} />
      </Flex>
    </Flex>
  );
}

export default observer(Assets)
